/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OptInDto } from './opt-in-dto';


export interface MembershipDto { 
    /**
     * Unique identifier of the membership
     */
    membershipId: string;
    /**
     * Program associated with the membership
     */
    program: string;
    /**
     * Partner ID linked to the membership
     */
    partnerId: string;
    /**
     * Account ID
     */
    accountId: string;
    /**
     * User ID
     */
    userId: string;
    /**
     * Role of the member within the program
     */
    memberRole: MembershipDto.MemberRoleEnum;
    /**
     * List of allowed opt-ins
     */
    allowedOptIns: Array<OptInDto>;
    /**
     * List of declined opt-ins
     */
    declinedOptIns: Array<OptInDto>;
    /**
     * Whether the membership is terminated
     */
    terminated: boolean;
}
export namespace MembershipDto {
    export type MemberRoleEnum = 'OWNER' | 'COOWNER' | 'COLLECTOR';
    export const MemberRoleEnum = {
        Owner: 'OWNER' as MemberRoleEnum,
        Coowner: 'COOWNER' as MemberRoleEnum,
        Collector: 'COLLECTOR' as MemberRoleEnum
    };
}


